import { render, staticRenderFns } from "./not.vue?vue&type=template&id=25098a8f&"
import script from "./not.vue?vue&type=script&lang=js&"
export * from "./not.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports